export const basket = {
  REQUEST: "sw::basket::request",
  RESPONSE: "sw::basket::response",
  SUCCESS: "sw::basket::success",
  FAILURE: "sw::basket::failure",
  addToBasket: {
    REQUEST: "sw::addToBasket::request",
    RESPONSE: "sw::addToBasket::response",
    SUCCESS: "sw::addToBasket::success",
    FAILURE: "sw::addToBasket::failure",
  },
  removeFromBasket: {
    REQUEST: "sw::removeFromBasket::request",
    RESPONSE: "sw::removeFromBasket::response",
    SUCCESS: "sw::removeFromBasket::success",
    FAILURE: "sw::removeFromBasket::failure",
  },
  clearBasket: {
    REQUEST: "sw::clearBasket::request",
    RESPONSE: "sw::clearBasket::response",
    SUCCESS: "sw::clearBasket::success",
    FAILURE: "sw::clearBasket::failure",
  },
  setBasketItemQuantity: {
    REQUEST: "sw::setBasketItemQuantity::request",
    RESPONSE: "sw::setBasketItemQuantity::response",
    SUCCESS: "sw::setBasketItemQuantity::success",
    FAILURE: "sw::setBasketItemQuantity::failure",
    START: "sw::setBasketItemQuantity::start",
    STOP: "sw::setBasketItemQuantity::stop",
    UPDATE: "sw::setBasketItemQuantity::update",
  },
};
